export enum FilterMode {
  day = 'day',
  month = 'month',
  year = 'year',
  total = 'total'
}